import React from "react";
import { NavLink } from "react-router-dom";
import "./sidebar.scss";
import nimaplogo from '../../../img/nimapLogo.png'
import sidebar from '../../../json/sidebar.json'
const Sidebar = ({ hideSidebar, handleCompressSidebar }) => {
  return (
    <div className="sidebar">
      <ul className="sidebar__firstul">
        <li className="sidebar__firstul--li">
          <span
          className="sidebar__firstul--li-imgspan"
          >
            <NavLink to="/dashboard" className="sidebar__firstul--li-nav">
              {/* <div className={`${hideSidebar?'sidebar__firstul--li-nav-toggle':"sidebar__firstul--li-nav-img1"}`}>
              </div> */}
              <img src={nimaplogo} alt="" className={"nimaplogo"} />
            </NavLink>
          </span>
          <span className="sidebar__firstul--li-span">
            {hideSidebar ? (
              <i
                className="fas fa-angle-double-right sidebar__firstul--li-span-arrow"
                onClick={handleCompressSidebar}
              ></i>
            ) : (
              <i
                className="fas fa-angle-double-left sidebar__firstul--li-span-arrow"
                onClick={handleCompressSidebar}
              ></i>
            )}
          </span>
        </li>
      </ul>
       <ul className='sidebar__secondul' >
                  { 
                    sidebar.map(header=>(
                      <>
                    {header.masterName !== "home"? 
                      <li key={header.id} className="sidebar__ul--li-1">
                        {hideSidebar ? (
                          <p className="sidebar__secondul--li-titleM">...</p>
                        ) : (
                          <p className="sidebar__secondul--li-title">{header.masterName}</p>
                        )}
                      </li>
                      : <li className="empty" ></li>
                      }
                      {
                        header.masterPanel.map(panel=>(
                          <li className="sidebar__secondul--li">
                          <NavLink exact   to={`${panel.link}`}
                          activeClassName='sidebar__secondul--li-nav-active'  
                          className='sidebar__secondul--li-nav'>
                          <span>
                              <i className={`${panel.name=="Dashboard"?"fab fa-buffer ":panel.name=="CreateCV"?"fab fa-delicious":"fa-solid fa-square "} sidebar__secondul--li-nav-i `}></i>
                          </span>
                          <span style={ {display:hideSidebar?"none":""}} >{panel.name}</span>
                          </NavLink>
                      </li>
                        ))
                      }
                      </>
                    )
                    )

                  }
       </ul>
    </div>
  );
};
export default Sidebar;